"use client";
import { cn } from "~/utils/fontsConfig";

interface ToggleGroupProps {
    children: React.ReactNode;
    className?: string;
}

export const ToggleGroup = ({ children, className }: ToggleGroupProps) => {
    return (
        <div
            className={cn(
                "flex w-max justify-start gap-1 rounded bg-v3-neutral p-1",
                className,
            )}
        >
            {children}
        </div>
    );
};
